import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toggle } from "@ts-digital/vrc";
import { DatePicker, InputNumber, Select, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getCollectionModesList, getCountriesList, getCustomCodesList, getDeliveyMethodList, updateDrawerFields } from "../../../../../store/actions/precog/intrastat";
import { VaporFormItem } from "../../../../vapor";
import "../style.css";

const Option = Select.Option;

const ServicesDrawer = ({ draftId, id, model }) => {

  // !newDetail?.doc?.active
  const dispatch = useDispatch();
  const deliveryMethodList = useSelector(state => state.intrastatDrawer.deliveryMethod?.list);
  const collectionModesList = useSelector(state => state.intrastatDrawer.collectionModes?.list);
  const customCodesList = useSelector(state => state.intrastatDrawer.customCodes?.list);
  const countriesList = useSelector(state => state.intrastatDrawer.countries?.list);

  const [selections, setSelections] = useState({
    deliveryMethod: undefined,
    collectionMode: undefined,
    paymentCountry: undefined,
    customCode: undefined,
    correctionYear: undefined,
    originalIntrastatRecord: undefined,
    statementNumber: undefined,
    rectification: false
  });
  const [deliveryMethodOptions, setDeliveryMethodOptions] = useState([]);
  const [collectionModesOptions, setCollectionModesOptions] = useState([]);
  const [customCodesOptions, setCustomCodesOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);

  useEffect(() => {
    dispatch(getDeliveyMethodList());
    dispatch(getCollectionModesList());
    dispatch(getCustomCodesList());
    dispatch(getCountriesList());
  }, []);

  useEffect(() => {
    if (!model) return;
    setSelections({
      deliveryMethod: model.deliveryMethod,
      collectionMode: model.collectionMode,
      paymentCountry: model.paymentCountry,
      customCode: model.customCode,
      correctionYear: model.correctionYear,
      originalIntrastatRecord: model.originalIntrastatRecord,
      statementNumber: model.statementNumber,
      rectification: model.rectification
    });
  }, [model]);

  useEffect(() => {
    if (!deliveryMethodList) return;
    setDeliveryMethodOptions(deliveryMethodList);
  }, [deliveryMethodList]);

  useEffect(() => {
    if (!collectionModesList) return;
    setCollectionModesOptions(collectionModesList);
  }, [collectionModesList]);

  useEffect(() => {
    if (!customCodesList) return;
    setCustomCodesOptions(customCodesList);
  }, [customCodesList]);

  useEffect(() => {
    if (!countriesList) return;
    setCountriesOptions(countriesList);
  }, [countriesList]);

  const onFieldChange = (fieldToChange) => {    
    dispatch(updateDrawerFields(
      draftId, id, fieldToChange
    ));
  };

  return (
    <div className="dbx-preCog-intrastat-add-nomenclatura-content">
      <div>
        <div className="dbx-preCog-intrastat-add-nomenclatura-row">
          Rettifica <span>
            <Toggle
              checked={selections.rectification}
              onChange={() => {
                setSelections({ ...selections, rectification: !selections.rectification });
                onFieldChange({ rectification: !selections.rectification });
              }}
            /></span>
          <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
        </div>
      </div>
      <div>
        <div>
          <VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.deliveryMethod"} /> *
              </div>
              <div>
                <Tooltip
                  placement="left"
                  title={<FormattedMessage id={"preCog.intrastatTab.tooltips.deliveryMethod"} />}
                  color={"#005075"}
                >
                  <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
                </Tooltip>
              </div></>
            }>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "100%" }}
              value={selections.deliveryMethod}
              placeholder="Seleziona modalità"
              onSelect={value => {
                setSelections({ ...selections, deliveryMethod: value });
                onFieldChange({ deliveryMethod: value });
              }}
            >
              {deliveryMethodOptions.map((el, index) => {
                return <Option key={`deliveryMethod${index}`} value={el.code}>
                  {el.description}
                </Option>;
              })}
            </Select>
          </VaporFormItem>
        </div>
      </div>
      <div>
        <div>
          <VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.collectionMode"} /> *
              </div>
              <div>
                <Tooltip
                  placement="left"
                  title={<FormattedMessage id={"preCog.intrastatTab.tooltips.collectionMode"} />}
                  color={"#005075"}
                >
                  <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
                </Tooltip>
              </div></>
            }>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              style={{ width: "100%" }}
              value={selections.collectionMode}
              placeholder="Seleziona modalità incasso"
              onSelect={value => {
                setSelections({ ...selections, collectionMode: value });
                onFieldChange({ collectionMode: value });
              }}
            >
              {collectionModesOptions.map((el, index) => {
                return <Option key={`collectionMode_${index}`} value={el.code}>
                  {el.description}
                </Option>;
              })}
            </Select>
          </VaporFormItem>
        </div>
      </div>
      <div>
        <div><VaporFormItem
          label={<>
            <div className="intrastat-form-label">
              <FormattedMessage id={"preCog.intrastatTab.paymentCountry"} /> *
            </div>
            <div>
              <Tooltip
                placement="left"
                title={<FormattedMessage id={"preCog.intrastatTab.tooltips.paymentCountry"} />}
                color={"#005075"}
              >
                <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
              </Tooltip>
            </div></>}>
          <Select
            showSearch
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSelect={value => {
              setSelections({ ...selections, paymentCountry: value });
              onFieldChange({ paymentCountry: value });
            }}
            style={{ width: "100%" }}
            value={selections.paymentCountry}
            placeholder="Seleziona paese"
          >
            {countriesOptions.map((el, index) => (
              <Option key={`destinationCountry_${index}`} value={el.isoCode}>
                {el.countryName}
              </Option>
            ))}
          </Select>
        </VaporFormItem>
        </div>
      </div>
      {selections.rectification && <>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.customCode"} /> *
              </div>
              <div>
                <Tooltip
                  placement="left"
                  title={<FormattedMessage id={"preCog.intrastatTab.tooltips.customCode"} />}
                  color={"#005075"}
                >
                  <FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} />
                </Tooltip>
              </div></>}>
            <Select
              showSearch
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              style={{ width: "100%" }}
              value={selections.customCode}
              placeholder="Seleziona codice"
              onSelect={value => {
                setSelections({ ...selections, customCode: value });
                onFieldChange({ customCode: value });
              }}
            >
              {customCodesOptions.map((el, index) => {
                return <Option key={`customCode_${index}`} value={el.code}>
                  {el.description}
                </Option>;
              })}
            </Select>
          </VaporFormItem>
          </div>
        </div>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.correctionYear"} /> *
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
            <DatePicker 
              picker="year"
              value={selections.correctionYear ? moment(selections.correctionYear.toString()) : undefined}
              onChange={(value) => {
                setSelections({...selections, correctionYear: moment(value).format("YYYY")});
                onFieldChange({correctionYear: moment(value).format("YYYY")});
              }}
              className="nomenclatura-input"
              getPopupContainer={(trigger) => trigger.parentNode}
              placeholder="Seleziona l'anno"
            />
          </VaporFormItem>
          </div>
        </div>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.originalIntrastatRecord"} /> *
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
            <InputNumber
              placeholder="-"
              style={{ width: "100%" }}
              className="nomenclatura-input"
              min={0}
              onChange={value =>
                setSelections({...selections, originalIntrastatRecord: value})
              }
              onBlur={() => onFieldChange({originalIntrastatRecord: selections.originalIntrastatRecord})}
              value={selections.originalIntrastatRecord}
            />
          </VaporFormItem>
          </div>
        </div>
        <div>
          <div><VaporFormItem
            label={<>
              <div className="intrastat-form-label">
                <FormattedMessage id={"preCog.intrastatTab.statementNumber"} /> *
              </div>
              <div><FontAwesomeIcon className="preCog-intrastat-drawer-info-circle-icon" icon={["fas", "info-circle"]} /></div></>}>
            <InputNumber
              placeholder="00"
              style={{ width: "100%" }}
              className="nomenclatura-input"
              min={0}
              onChange={value =>
                setSelections({...selections, statementNumber: value})
              }
              onBlur={() => onFieldChange({statementNumber: selections.statementNumber})}
              value={selections.statementNumber}
            />
          </VaporFormItem>
          </div>
        </div>
      </>}
    </div>
  );
};

export default ServicesDrawer;
